<div class="auth-container" [ngClass]="{ mobile: isMobile$ | async }">
  <mat-card>
    <h1 class="mat-headline-3">{{ 'WM_TECH.AUTH.PASSWORD.TITLE' | translate }}</h1>
    <h3 class="mat-subtitle-2">
      {{ 'WM_TECH.AUTH.PASSWORD.DESCRIPTION' | translate }}
    </h3>

    <mat-card-content>
      <form [formGroup]="forgotPasswordForm" (ngSubmit)="sendResetInstructions()">
        <mat-form-field appearance="outline" class="wm-input">
          <input formControlName="email" [placeholder]="'WM_TECH_POOL.FORMS.EMAIL' | translate" matInput type="email" required />
        </mat-form-field>

        <button mat-raised-button color="tech-button-bg-primary" type="submit" class="submit-button" [disabled]="forgotPasswordForm.invalid">
          {{ 'WM_TECH.PASSWORD.FORGOT.SEND' | translate }}
        </button>
      </form>

      <div class="auth-links">
        <p>
          {{ 'WM_TECH.AUTH.PASSWORD.RETURN_TO' | translate }}
          <a routerLink="/auth/sign-in">{{ 'WM_TECH.AUTH.PASSWORD.SIGNIN' | translate }}.</a>
        </p>
      </div>
    </mat-card-content>
  </mat-card>
</div>
